export const MULTISELECT_ADD_ITEM = 'MULTISELECT_ADD_ITEM'
export const MULTISELECT_ADD_ALL = 'MULTISELECT_ADD_ALL'
export const MULTISELECT_REMOVE_ITEM = 'MULTISELECT_REMOVE_ITEM'
export const MULTISELECT_CLEAR = 'MULTISELECT_CLEAR'

export const UPDATE_MODAL_VISIBILITY = 'UPDATE_MODAL_VISIBILITY'


